import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ProcessRunService } from '../../process-runner-select/shared/process-run.service';
import { UIService } from '../../shared/ui.service';
import { getmissFieldsRes, ProcessRun } from '../missifelds';
import { MissingFieldsService } from '../missing-fields.service';
@Component({
  selector: 'app-missing-fields-client',
  templateUrl: './missing-fields-client.component.html',
  styleUrls: ['./missing-fields-client.component.css']
})
export class MissingFieldsClientComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private mrs: MissingFieldsService, public uis: UIService, private prss: ProcessRunService) {
    //this.get_progressLogs();
    this.getCLients();
  }
  clients: any = [];
  getCLients() {
    this.prss.getClientes('auc').subscribe((r: any) => {
      this.clients = r;
      console.log(r)
    }, (err) => { })
  }


  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  isLoading: boolean = false;
  getStatus() {
    if (this.isLoading) {
      return 'load';
    } else if (!this.isLoading && this.dataSource.data.length == 0) {
      return 'nf';
    }
  }


  get_progressLogs() {
    if (!this.clientttt) {
      return 1;
    }
    this.alldata = [];
    this.dataSource.data = this.alldata;
    let obj = {
      startTime: this.getFormattedDate(this.dates),
      endTime: this.getFormattedDate(this.dates),
      //endTime: this.dates,
      clientId: this.clientttt
    }
    //console.log(obj)
    this.isLoading = true;

    this.mrs.get_missFields(obj).subscribe((r: getmissFieldsRes) => {
      //console.log(r)
      this.alldata = r.processRuns.filter((e) => {
        return e.missingFieldCount > 0
      })
      this.dataSource.data = this.alldata;
      this.isLoading = false;

      //let obk = r.processRuns[0];
      //let arr = [];
      //for (let i = 0; i < 101; i++) {
      //  arr.push(obk);
      //}
      //this.dataSource.data = arr;
    }, (er) => {
      this.isLoading = false;

    })
  }
  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;

  }
  displayedColumns: string[] = ['p_id', 'sdate', 'edate', 'status', 'dload'];
  dataSource = new MatTableDataSource<ProcessRun>();
  alldata: ProcessRun[] = [];

  getMissField(p_id, c_id, count) {

    if (count && count > 0) {

      this.mrs.getMissingFieldsReport(p_id, c_id).subscribe((r: any) => {
        console.log(r)
        if (r.status == 400 || r.statusCode == 404 || r.body.type != "text/csv") {
          this.uis.showSnackbar("No Missing Fields Found", "Ok", 2000, false)
          return 1;
        }
        let blob: Blob = r.body as Blob;
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        let filename = "MissingFields";
        a.setAttribute("download", filename + ".csv");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

      }, (er) => {
        this.uis.showSnackbar("No Missing Fields Found", "Ok", 2000, false)
      })
    } else {
      this.uis.showSnackbar("No Missing Fields Found", "Ok", 2000, false)
    }
  }

  resetFilters() {
    this.alldata = [];
    this.dataSource.data = this.alldata;
    this.dates = null;
    this.datee = null;
    this.clientttt = null;

  }
  dates: any = null;
  datee: any = null;
  clientttt: any = null;
  getDateinMili(e) {
    //console.log(e)
    let d = new Date(e).getDate().toString();
    let m = (new Date(e).getMonth() + 1).toString();
    let y = new Date(e).getFullYear().toString();
    let time: any = d + "-" + m + "-" + y;
    //console.log(time)
    time = new Date(time).getTime();
    return time;
  }
  getFormattedDate(d) {
    if (d) {
      let date = new Date(d);
      let z = date.getDate() <= 9 ? '0' : '';

      const year = date.getFullYear(),
        month = ('0' + (date.getMonth() + 1)).slice(-2),
        day = (z + date.getDate().toString().slice(-2))
      //day = date.getDate()

      return [year, month, day].join('-')
    } else {
      return null;
    }
  }

  changeSate() {
    this.get_progressLogs();
  }
  resetFiltersOld() {
    this.dates = null;
    this.get_progressLogs();
  }

}
